import { makeStylesV5 } from '../../components';
import CssVariables from './css-variables';
const CssClasses = makeStylesV5()(() => ({
    dFlexCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    pinkButton: {
        color: CssVariables.pink,
        backgroundColor: CssVariables.pinkLight,
        backgroundRepeat: 'no-repeat',
        backgroundClip: 'padding-box',
        ['&:hover']: {
            backgroundColor: CssVariables.pinkHover,
        }
    },
    textFieldCustom: {
        marginBottom: 14,
        '& .MuiFormLabel-root': {
            fontSize: 10,
            marginBottom: 6,
            color: CssVariables.labelLight,
            position: 'unset',
            transform: 'none',
        },
        '& .MuiInputBase-root input': {
            padding: '10.5px 14px',
            maxHeight: 40
        },
        '& .MuiInputBase-root fieldset': {
            top: 0
        },
        '& .MuiInputBase-root fieldset legend': {
            display: 'none',
        },
    },
}));
const dflexJustifyCenter = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
};
const container = {
    height: '100%',
    padding: 20,
    overflow: 'auto',
    minWidth: `calc(760px - ${CssVariables.drawerWidth}px)`,
};
const titleRow = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
    '& .MuiTypography-root': {
        fontFamily: CssVariables.fontFamilyLato,
        fontWeight: 900,
        fontSize: 20,
    },
};
const borderBox = {
    border: '1px solid #E4E4E4',
    borderRadius: 8,
    backgroundColor: CssVariables.white,
};
const formInputContainer = {
    marginBottom: 40,
    '& h6': {
        height: 19,
        fontSize: 14,
        fontWeight: 800,
        color: '#222222',
    },
};
const footerSection = {
    minHeight: 70,
    borderTop: '1px solid #DEDEDE',
    alignItems: 'center',
    padding: '0 15px',
};
const footerBtn = {
    padding: '8px 24px',
    height: 34,
    minWidth: '110px'
};
const tableGrid = {
    border: 0,
    '& .MuiDataGrid-overlay': {
        backgroundColor: '#fff'
    },
    '& .MuiDataGrid-columnsContainer': {
        backgroundColor: CssVariables.columnHeader,
        font: 'normal normal 600 12px/15px Open Sans',
        color: '#000000de',
        '& .MuiDataGrid-columnHeader': {
            paddingRight: 0,
            ['&:focus, &:focus-within']: {
                outline: 'unset',
            },
            '& .MuiDataGrid-columnHeaderTitleContainer, .MuiDataGrid-columnHeaderTitle': {
                flex: 1,
                padding: 0,
            },
            '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600
            },
            '& .MuiDataGrid-menuIcon': {
                visibility: 'visible',
                marginRight: 2,
            }
        },
    },
    '& .MuiDataGrid-row': {
        fontSize: 13,
        color: '#222222',
        '& .MuiDataGrid-cell:focus,& .MuiDataGrid-cell:focus-within': {
            outline: 'unset',
        },
        '& .iconButton': {
            '& .MuiIconButton-root': {
                ['&:hover']: {
                    backgroundColor: 'unset',
                }
            }
        },
        ['&:hover']: {
            backgroundColor: CssVariables.tableRow,
            '& .date-with-trash-icon svg': {
                opacity: 1
            }
        },
        '& .date-with-trash-icon': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            '& span': {},
            '& svg': {
                opacity: 0,
                height: 20,
                width: 20,
                color: '#C4C4C4'
            }
        },
        '& .MuiDataGrid-cell:focus': {
            outline: 'unset',
        },
        '&.Mui-selected': {
            backgroundColor: CssVariables.tableRow,
            ['&:hover']: {
                backgroundColor: CssVariables.tableRow,
            },
        },
    },
};
const modalHeader = {
    height: 60,
    display: 'flex',
    alignItems: 'center',
    background: CssVariables.cardTitleBackground,
    color: CssVariables.white,
    opacity: 0.65,
    '& h2': {
        fontSize: 14,
        fontWeight: 'bold',
    }
};
export { dflexJustifyCenter, container, titleRow, borderBox, formInputContainer, footerSection, footerBtn, tableGrid, modalHeader };
export default CssClasses;
//# sourceMappingURL=css-classes.js.map